import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";

const FAQS = [
  {
    q: "How do subscriptions and Restore Purchases work?",
    a: "HAEVEN Premium is $9.99/month or $99.99/year, billed through the App Store or Google Play on supported mobile builds. Subscriptions renew automatically unless canceled in your store account. To restore an existing subscription on a new device, open HAEVEN Premium → tap \"Restore purchases\". Manage or cancel anytime in your device's subscription settings (iOS: Settings → Apple Account → Subscriptions; Android: Play Store → Payments & subscriptions).",
  },
  {
    q: "How do I delete my account?",
    a: "Open Settings → Delete account. This permanently removes your profile, posts, messages, moods, and journals. Deletion is immediate and cannot be undone.",
  },
  {
    q: "How do I export my data?",
    a: "Open Settings → Export my data. You'll receive a complete copy of your HAEVEN data (profile, posts, messages, moods, journals) as a downloadable file.",
  },
  {
    q: "How do I report content or block someone?",
    a: "Tap the flag icon on any post to report it — our team and AI moderation review every report. To block a user, visit their profile and tap Block, or manage blocks in Settings → Blocked accounts. Blocked users can't see your posts or message you.",
  },
  {
    q: "Is HAEVEN a mental-health service?",
    a: "No. HAEVEN's mood check-ins and journal are wellness tools, not a substitute for professional care. If you're in crisis, please contact a qualified clinician or your local emergency line.",
  },
];

export default function SupportPage() {
  return (
    <div className="min-h-screen bg-background grain px-4 py-10" data-testid="support-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/" data-testid="support-back-btn" className="brutal-btn inline-flex items-center gap-2 px-3 py-2 bg-card mb-6">
          <ArrowLeft size={14} strokeWidth={2.5} /> Back
        </Link>
        <article className="brutal-card bg-card p-6 md:p-10 space-y-6">
          <div>
            <h1 className="text-4xl mt-2">HAEVEN Support</h1>
            <p className="leading-relaxed mt-3 text-muted-foreground">
              We're here to help. Check the answers below, or reach out directly — we reply to every message.
            </p>
          </div>
          <a
            href="mailto:support@haeven.world"
            data-testid="support-email-link"
            className="brutal-btn inline-flex items-center gap-2 px-4 py-3 bg-primary text-primary-foreground font-semibold"
          >
            <Mail size={16} strokeWidth={2.5} /> support@haeven.world
          </a>
          <div className="space-y-5">
            <h2 className="text-2xl mt-2">Frequently asked questions</h2>
            {FAQS.map((f) => (
              <div key={f.q} className="border-t-2 border-foreground/10 pt-4">
                <h3 className="text-xl font-semibold">{f.q}</h3>
                <p className="leading-relaxed mt-2 text-muted-foreground">{f.a}</p>
              </div>
            ))}
          </div>
          <p className="text-sm text-muted-foreground pt-2">
            See also our <Link to="/privacy" className="underline" data-testid="support-privacy-link">Privacy Policy</Link> and{" "}
            <Link to="/terms" className="underline" data-testid="support-terms-link">Terms of Service</Link>.
          </p>
        </article>
      </div>
    </div>
  );
}
